import firstImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\1st.png";
import secondImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\2nd.png";
import thirdImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\3rd.png";
import fourthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\4th.png";
import fifthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\5th.png";
import sixthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\6th.png";
import seventhImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\7th.png";
import eighthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\8th.png";
import ninthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\9th.png";
import tenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\10th.jpg";
import eleventhImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\11th.png";
import twelfthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\12th.png";
import thirteenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\13th.png";
import fourteenImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\14th.png";
import fifteenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\15th.png";
import sixteenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\16th.png";
import seventeenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\17th.png";
import eighteenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\18th.png";
import nineteenthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\19th.png";
import twentiethImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\20th.png";
import twentyFirstImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\21st.png";
import twentySecondImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\22nd.png";
import twentyThirdImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\23rd.png";
import twentyFourthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\24th.png";
import twentyFifthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\25th.png";
import twentySixthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\26th.gif";
import twentySeventhImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\27th.png";
import twentyEighthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\28th.png";
import twentyNinthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\29th.png";
import thirtiethImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\30th.gif";
import thirtyFirstImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\31st.png";
import thirtySecondImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\32nd.png";
import thirtyThirdImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\33rd.png";
import thirtyFourthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\34th.png";
import thirtyFifthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\35th.png";
import thirtySixthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\36th.png";
import thirtySeventhImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\37th.png";
import thirtyEighthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\38th.png";
import thirtyNinthImg from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\39th.png";
import tiny from "..\\..\\..\\..\\src\\markdown\\dynamicPagesInfo\\Analysis\\images\\tiny.png";
import * as React from 'react';
export default {
  firstImg,
  secondImg,
  thirdImg,
  fourthImg,
  fifthImg,
  sixthImg,
  seventhImg,
  eighthImg,
  ninthImg,
  tenthImg,
  eleventhImg,
  twelfthImg,
  thirteenthImg,
  fourteenImg,
  fifteenthImg,
  sixteenthImg,
  seventeenthImg,
  eighteenthImg,
  nineteenthImg,
  twentiethImg,
  twentyFirstImg,
  twentySecondImg,
  twentyThirdImg,
  twentyFourthImg,
  twentyFifthImg,
  twentySixthImg,
  twentySeventhImg,
  twentyEighthImg,
  twentyNinthImg,
  thirtiethImg,
  thirtyFirstImg,
  thirtySecondImg,
  thirtyThirdImg,
  thirtyFourthImg,
  thirtyFifthImg,
  thirtySixthImg,
  thirtySeventhImg,
  thirtyEighthImg,
  thirtyNinthImg,
  tiny,
  React
};